import Selector from "../../components/Selector";
import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import authFetch from "../../api/authFetch";

const Activities = ({tabs = ['Catalan (Central)','Spanish (Castilian)', 'English', 'Italian', 'Greek', 'Norwegian']}) => {
    const {setAuth} = useAuth();
    const [activeUsers, setActiveUsers] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [picked, setPicked] = useState(null);
    const [pickedInfo, setPickedInfo] = useState(null);
    
    const types = ['ListenAndWrite', 'ListenAndClick', 'ListenAndClickII', 'ListenAndSpeak'];

    useEffect(() => {
        authFetch(`/stats/active_users/${tabs[activeTabIndex]}`, {
            method: "GET"
        }).then(response => {
            if (response.ok) {
                return response.json();
            }
            if (response.status === 401) {
                localStorage.removeItem("token");
                setAuth({});
            }
        }).then(json => {
            if (json) {
                setActiveUsers(json);
            }
        });
    },[activeTabIndex]);

    useEffect(() => {
        if (picked) {
            authFetch(`/stats/haloinfo/${tabs[activeTabIndex]}/${picked}`, {
                method: "GET"
            }).then(response=>{
                if (response.ok) {
                    return response.json();
                }
                if (response.status === 401) {
                    localStorage.removeItem("token");
                    setAuth({});
                }
            }).then(json=>{
                setPickedInfo(json);                
            });
        } 
    },[picked, activeTabIndex]); 


    return <div className="panel-stack">
        <div>
            <p className="panel-heading">Activity overview</p>
            <h2 className="mt-1 text-2xl font-bold text-cyan-950">Learner progress</h2>
        </div>
        <Selector 
            clickHandler={tab_index => {
                setActiveTabIndex(tab_index);
                setPicked(null);
                setPickedInfo(null);
            }} 
            tabsData={tabs}
            active={activeTabIndex}        
        />
        <div className="management-grid">
                <section className="panel panel-body">
                    <div className="flex items-center justify-between">
                        <h3 className="panel-heading">Active users</h3>
                        <span className="status-pill">{activeUsers.filter(Boolean).length}</span>
                    </div>
                        <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                            {activeUsers.length > 0 && activeUsers.map(user => user && <button
                                onClick={()=>{setPicked(user)}}
                                className={`truncate rounded-xl border px-4 py-3 text-left font-bold transition ${
                                    picked === user
                                    ? "border-cyan-400 bg-cyan-50 text-cyan-900"
                                    : "border-slate-200 bg-white text-slate-600 hover:border-cyan-200 hover:bg-slate-50"
                                }`}
                                key={user}
                            >
                                {user}
                            </button>)}
                            {activeUsers.length === 0 && <div className="empty-state sm:col-span-2">No recent activity for this course.</div>}
                        </div>
                </section>

                <section className="panel panel-body">
                    <div className="mb-4">
                        <h3 className="panel-heading">Exercise details</h3>
                        <p className="mt-1 truncate text-xl font-bold text-cyan-950">{picked || "Select a learner"}</p>
                    </div>
                    {pickedInfo ? <div className="panel-stack">
                            {Object.keys(pickedInfo).map(key => <div className="rounded-xl border border-slate-200 p-4" key={key}>
                                <div className="mb-3 font-bold text-cyan-900">{key}</div>
                                <div className="flex flex-col gap-2">
                                        {Object.keys(pickedInfo[key]).filter(akey => types.includes(akey)).map(akey => <div className="list-row" key={akey}>
                                            <span className="text-sm font-semibold text-slate-600">{akey}</span>
                                            <span className={`status-pill ${pickedInfo[key][akey].passed ? "!bg-emerald-50 !text-emerald-700" : "!bg-red-50 !text-red-700"}`}>
                                                {pickedInfo[key][akey].passed ? "Passed" : "Needs practice"}
                                            </span>
                                        </div>)}
                                        <div className="list-row">
                                            <span className="text-sm font-semibold text-slate-600">Fulfilled</span>
                                            <span className="font-bold text-cyan-900">{String(pickedInfo[key].fulfilled)}</span>
                                        </div>
                                    </div>
                            </div>)}
                    </div> : <div className="empty-state">Choose a learner to inspect their recent exercises.</div>}
                </section>
        </div>
    </div>
}

export default Activities;
